import React from 'react'
import { MaterialSymbolsRefresh } from '../../assets/icons/Icons'
import { useDispatch } from 'react-redux';
import { setIsFetching } from '../../features/modal/modalSlice';

interface RefetchProps {
    refetch?: () => Promise<any> | void;
    size?: number;
    btnStyle?: string;
}

export default function Refetch({ refetch, size, btnStyle }: RefetchProps) {

    const dispatch = useDispatch();
    const handleClick = async () => {
        try {
            dispatch(setIsFetching(true)); // start main data loading
            await refetch?.();
        } finally {
            setTimeout(() => {
                dispatch(setIsFetching(false)); // stop loading
            }, 500);
        }
    };

    return (
        <div className='flex justify-center items-center'>
            <button
                className={`${btnStyle?.length === 0 ? 'bg-cbColor px-1 py-1' : btnStyle?.length} rounded`}
                onClick={handleClick}
            >
                <MaterialSymbolsRefresh height={size} width={size}/>
            </button>
        </div>
    )
}
